import { Wrapper, Status } from '@googlemaps/react-wrapper';
import { LayoutProps } from '@doar/shared/styled';
import { MapKey } from '@doar/shared/data';
import Map from './map';
import Marker from './marker';
import { StyledMap } from './style';
import { useState, useEffect } from 'react';

const render = (status: Status) => {
    return <h1>{status}</h1>;
};

type MapProps = google.maps.MapOptions &
    LayoutProps & {
        marker?: boolean;
        locationData?: {
            lat?: number;
            lng?: number;
            status?: string;
        };
    };

const MyMap: React.FC<MapProps> = ({
    width,
    height,
    marker,
    locationData,
    ...options
}) => {
    const [latitude, setLatitude] = useState<number>(0);
    const [longitude, setLongitude] = useState<number>(0);
    const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
    const [mapZoom, setMapZoom] = useState(12);

    /*
    useEffect(() => {
        let watchId: number;

        if ('geolocation' in navigator) {
            watchId = navigator.geolocation.watchPosition(
                (position) => {
                    const myLat = position.coords.latitude;
                    const myLng = position.coords.longitude;

                    setLatitude(myLat);
                    setLongitude(myLng);

                    // หากมีข้อมูลตำแหน่งไม้เท้า
                    if (
                        locationData &&
                        locationData.lat !== undefined &&
                        locationData.lng !== undefined
                    ) {
                        const newCenter = {
                            lat: (myLat + locationData.lat) / 2,
                            lng: (myLng + locationData.lng) / 2,
                        };
                        setMapCenter(newCenter);

                        const zoom = calculateZoomLevel(
                            { lat: myLat, lng: myLng },
                            { lat: locationData.lat, lng: locationData.lng }
                        );
                        setMapZoom(zoom);
                    } else {
                        // ถ้ายังไม่มีไม้เท้าให้ center ที่ผู้ใช้ก่อน
                        setMapCenter({ lat: myLat, lng: myLng });
                        setMapZoom(15);
                    }
                },
                (error) => {
                    console.error('Error watching position:', error);
                },
                { enableHighAccuracy: true }
            );
        } else {
            console.warn('Geolocation not supported.');
        }

        return () => {
            if (watchId) navigator.geolocation.clearWatch(watchId);
        };
    }, [locationData]);
    */

    /*
    const calculateZoomLevel = (
        marker1: { lat: number; lng: number },
        marker2: { lat: number; lng: number }
    ) => {
        const GLOBE_WIDTH = 256;
        const west = marker1.lng;
        const east = marker2.lng;
        let angle = east - west;
        if (angle < 0) angle += 360;
        const zoom = Math.round(
            Math.log((window.innerWidth * 360) / angle / GLOBE_WIDTH) / Math.LN2
        );
        return zoom;
    };
    */

    useEffect(() => {
        // เมื่อ locationData เปลี่ยนแปลง และมีค่า lat/lng ที่ถูกต้อง
        if (
            locationData &&
            locationData.status === 'ok' && // ตรวจสอบสถานะด้วย
            locationData.lat !== undefined &&
            locationData.lng !== undefined
        ) {
            setMapCenter({ lat: locationData.lat, lng: locationData.lng });
            setMapZoom(15); // ซูมใกล้ขึ้นเมื่อมีตำแหน่งไม้เท้า
        } else {
            // ถ้าไม่มีข้อมูลไม้เท้า ให้กลับไปที่ค่า default (กรุงเทพฯ)
            setMapCenter({ lat: 13.736717, lng: 100.523186 });
            setMapZoom(12);
        }
    }, [locationData]);

    return (
        <StyledMap width={width} height={height}>
            <Wrapper apiKey={MapKey} render={render}>
                <Map {...options} center={mapCenter} zoom={mapZoom}>
                    {/* Marker ของเรา
                    {marker && latitude !== 0 && longitude !== 0 && (
                        <Marker position={{ lat: latitude, lng: longitude }} />
                    )} */}

                    {/* Marker ของไม้เท้า */}
                    {locationData?.status === 'ok' &&
                        locationData.lat !== undefined &&
                        locationData.lng !== undefined && (
                            <Marker
                                position={{
                                    lat: locationData.lat,
                                    lng: locationData.lng,
                                }}
                            />
                        )}
                </Map>
            </Wrapper>
        </StyledMap>
    );
};

// MyMap.defaultProps = {
//     center: { lat: 0, lng: 0 },
//     width: '100%',
//     height: '600px',
//     zoom: 12,
// };

export default MyMap;
